module.exports = __webpack_public_path__ + "static/media/unlockIcon.580423d0.svg";